import React from 'react';
import { useController } from 'react-hook-form';
import classNames from 'classnames';
import styles from './Field.module.css';

function Field({ name, label, icon, className, component: Input, ...rest }) {
  const {
    field: { value, onChange }
  } = useController({ name });

  return (
    <div className={classNames(styles.root, className, { [styles.labeless]: !label })}>
      {label && (
        <div className={styles.label}>
          <span className={styles.labelText}>{label}</span>
          {icon}
        </div>
      )}
      <div className={styles.input}>
        <Input {...rest} value={value} onChange={onChange} />
      </div>
    </div>
  );
}

export default Field;
